// Served via Authera's own backend proxy so no third-party host leaks in the
// production HTML/CSS. Backend fetches once and caches; frontend just hits
// same-origin `/api/public/logo.png`.
const LOGO_URL = "/api/public/logo.png";

// Standard size tokens used across the app.
const SIZE_TO_PX = {
  sm: 32, // header / nav
  md: 48, // login card
  lg: 80, // certificate seal (verify page, claim page)
};

/**
 * Authera square brand mark. Single source of truth for the logo treatment.
 *
 * Props:
 *   - size: "sm" | "md" | "lg"   (default "md")
 *   - glow: boolean              (default false). When true, applies the
 *           premium blue cast halo used on certificate seals.
 *   - testid: optional data-testid
 *
 * Numeric `size` is also accepted for backwards-compat with earlier callers
 * (Verify page passed size={64}).
 */
export default function AutheraLogo({ size = "md", glow = false, className = "", testid }) {
  const px =
    typeof size === "number" ? size : SIZE_TO_PX[size] ?? SIZE_TO_PX.md;

  return (
    <div
      data-testid={testid || "authera-logo"}
      className={`inline-flex items-center justify-center rounded-2xl bg-[#0055FF] overflow-hidden ${glow ? "shadow-[0_10px_30px_rgba(59,130,246,0.45)]" : "shadow-[0_2px_8px_rgba(0,85,255,0.35)]"} ${className}`}
      style={{ width: px, height: px }}
    >
      {/* Inner shield mark fills the blue tile. The source PNG has its own
        * built-in whitespace ring, which gives the brand seal its breathing
        * room — adding extra wrapper padding makes the mark read as a "dot"
        * inside larger badges. */}
      <img
        src={LOGO_URL}
        alt="Authera"
        className="w-full h-full object-contain"
        style={{ width: px, height: px }}
      />
    </div>
  );
}
